import { Tooltip, Box, Typography } from "@mui/material";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

/**
 * A helper component to display a label text with an information icon 
 * that reveals a tooltip on hover.
 */
export const InfoLabel = ({ text, tooltip }: { text: string, tooltip: string }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
    <Typography variant="body1">{text}</Typography>
    <Tooltip title={tooltip} placement="top" arrow>
      <InfoOutlinedIcon sx={{ fontSize: 18, color: 'text.secondary', cursor: 'pointer' }} />
    </Tooltip>
  </Box>
);